import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface IProps {
	setDisplayOverlay: (input: boolean) => void;
	id?: string;
}

const BtnDownloadPdf = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<button
			type="button"
			style={{ width: '2.5rem', height: '2.5rem', fontSize: '0.8rem' }}
			className="btn btn-outline-secondary"
			onClick={() => props.setDisplayOverlay(true)}
		>
			<FontAwesomeIcon icon={faFilePdf as IconProp} />
		</button>
	);
};

export default BtnDownloadPdf;
